export default {
      id: "icon--chevron-down-usage",
      viewBox: "0 0 10 6",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--chevron-down",
      toString: function () {
        return this.url;
      }
    }